import { formatearFechaCompleta } from "../../../../utils/utils";
import AnuncioWhatsApp from "../utilsWhatsapp/AnuncioWhatsapp";
import { Clock, Check, CheckCheck, X, TriangleAlert } from 'lucide-react';

const IconoPlay = () => (
  <svg className="absolute w-12 h-12 text-white opacity-80" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 5v14l11-7z" />
  </svg>
);

const MessageStatusIcon = ({ status }) => {
    const iconSize = 16;
    const className = "inline-block ml-1"; // Margen a la izquierda para separarlo de la hora

    switch (status) {
        case 'sent_baseData':
            // Reloj para 'enviando'
            return <Clock size={iconSize} className={className} />;
        case 'sent':
            // Un check para 'enviado'
            return <Check size={iconSize} className={className} />;
        case 'delivered':
            // Doble check para 'entregado'
            return <CheckCheck size={iconSize} className={className} />;
        case 'read':
            // Doble check azul para 'leído'
            return <CheckCheck size={iconSize} className="inline-block ml-1 text-sky-400" />;
        case 'failed':
            // Doble check azul para 'leído'
            return <X size={iconSize} className="inline-block ml-1 text-red-500" />;
        default:
            // Si el estado es desconocido o no aplica, no muestra nada.
            return null;
    }
};

export const MensajeContainer = ({mensaje, onAbrirImagen, onAbrirVideo}) =>{

    const texto = mensaje.content.body;
    const tipoMensaje = mensaje.message_type;
    const fechaMensaje = mensaje.timestamp;
    const esEnviado = mensaje.is_from_user;

    //documentos
    const mime_type = mensaje.content.mime_type;
    const file_size = mensaje.content.file_size;
    const url_archivo = mensaje.content.url_archivo;
    const nombre_archivo = mensaje.content.file_Name;
    const datosPublicidad = mensaje.content.publicidad_mensaje;
    const idArchivo =  mensaje.content.id_archivo;

    //error


    const MensajeContainer = () =>{
        switch(tipoMensaje){
            case 'text':
                return <p className="whitespace-pre-wrap">{texto}</p>;
            case 'image':
            case 'sticker':
                return (
                    // ✨ 2. Haz que el contenedor de la imagen sea clickeable
                    <div onClick={() => onAbrirImagen(url_archivo)} className="cursor-pointer">
                    <img 
                        src={url_archivo} // <-- Confirma que esta es la ruta correcta según tu console.log
                        alt="Imagen adjunta" 
                        className="rounded-lg mb-1 w-48"
                    />
                    {mensaje.content.caption && <p>{mensaje.content.caption}</p>}
                    </div>
                    );
            case 'document':
                return (
                <a
                    href={url_archivo}
                    target="_blank" // Para abrir en una nueva pestaña
                    rel="noopener noreferrer"
                    download // Atributo opcional para sugerir la descarga
                    className="flex items-center gap-x-3 p-2 rounded-lg bg-gray-100 text-black hover:bg-gray-200 transition-colors w-full"
                >
                    {/* El ícono cambia según el tipo de archivo 
                    {getIconoPorMimeType(mimetype)}*/}
                    
                    {/* Información del archivo */}
                    <div className="flex flex-col text-left overflow-hidden">
                    <span className="font-semibold truncate">{nombre_archivo || 'Documento'}</span>
                    <span className="text-xs text-gray-500">{file_size || 'Abrir archivo'}</span>
                    </div>
                </a>
                );
            case 'video':
                return (
                <div
                    onClick={() => onAbrirVideo(url_archivo)}
                    className="relative cursor-pointer flex justify-center items-center bg-black rounded-lg"
                >
                    {/* Usamos una etiqueta <video> para la vista previa, pero sin controles */}
                    <video
                    src={url_archivo}
                    //poster={thumbnail_url} // Muestra la imagen previa
                    preload="metadata"      // Carga solo la información básica del video
                    className="rounded-lg max-w-xs opacity-70"
                    >
                    </video>
                    
                    {/* Superponemos el ícono de Play */}
                    <IconoPlay />

                    {/* Mostramos el caption si existe */}
                    {texto && (
                    <p className="absolute bottom-1 left-2 text-white text-xs font-semibold bg-black bg-opacity-50 px-1 rounded">
                        {texto}
                    </p>
                    )}
                </div>
                );
            case 'audio':
                return (
                <div className="flex items-center gap-x-2 w-64">
                    {/* La etiqueta <audio> con 'controls' crea un reproductor completo.
                    'preload="metadata"' es una optimización para que el navegador 
                    solo cargue la información básica del audio (como la duración) al inicio.
                    */}
                    <audio
                    src={url_archivo}
                    controls
                    preload="metadata"
                    className="w-full"
                    >
                    Tu navegador no es compatible con el elemento de audio.
                    </audio>
                </div>
                );
            case 'textad':
               return (
                    <AnuncioWhatsApp 
                    adData={datosPublicidad} 
                    userMessage={texto}
                    />
                );
            case 'documenterror':
            case 'imageerror':
                return <p className="">Error en la descarga del documento {nombre_archivo} {idArchivo}</p>;
            default:
                return <p className="italic text-gray-400">[Mensaje de tipo '{mensaje.message_type}' no soportado]</p>;
        }
    }
     
    return (
        <div
            key={mensaje.id}
            className={`relative max-w-[70%] p-3 pt-2 pb-1 rounded-lg text-sm flex flex-col ${
                !mensaje.is_from_user // false = derecha (enviado por ti)
                    ? 'bg-blue-500 text-white self-end'
                    : 'bg-white text-gray-800 self-start shadow-sm'
            }`}
        >

            {!mensaje.is_from_user && (
                <span className="block text-xs font-semibold mb-1">
                    {mensaje.nameuser}
                </span>
            )}

            {/* El contenido del mensaje (imagen, texto, etc.) va aquí */}
            <div>{MensajeContainer()}</div>

            {/* --> INICIO DE LA MODIFICACIÓN <-- */}
            {/* Contenedor para la hora y el estado, alineado a la derecha */}
            <div className="flex items-center self-end mt-1">
                <span className={`text-xs ${
                    !mensaje.is_from_user ? 'text-blue-200' : 'text-gray-400'
                }`}>
                    {new Date(fechaMensaje).toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit', hour12: true })}
                </span>
                
                {!mensaje.is_from_user && <MessageStatusIcon status={mensaje.latest_status} />}

                {/* 👇 2. Reemplaza tu bloque de error por este */}
                {mensaje.latest_error && (
                    <div className="relative group ml-2 cursor-pointer">
                        {/* --- Icono de Alerta (sin cambios) --- */}
                        <TriangleAlert className="h-4 w-4 text-red-400" />

                        {/* --- Tooltip (con clases de posicionamiento actualizadas) --- */}
                        <div className="absolute right-full top-1/2 -translate-y-1/2 mr-2 w-max max-w-xs
                                    hidden group-hover:block bg-gray-800 text-white text-xs 
                                    rounded-lg shadow-lg p-3 z-10">
                            <p className="font-bold border-b border-gray-600 pb-1 mb-1">{mensaje.latest_error[0].title}</p>
                            <p>{mensaje.latest_error[0].error_data.details}</p>
                            <p className="text-gray-400 text-right mt-2 text-[10px]">Code: {mensaje.latest_error[0].code}</p>
                        </div>
                    </div>
                )}
            </div>
            {/* --> FIN DE LA MODIFICACIÓN <-- */}
        </div>
    );

}